import React, { useEffect } from 'react';
import {
  Link,
  FormLayout,
  TextField,
  Form,
  Text,
  ProgressBar,
  InlineStack,
  Button,
  ContextualSaveBar,
  BlockStack,
  InlineGrid,
  Box,
  Card,
  Divider,
} from '@shopify/polaris';
import { SaveIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import helpers from 'helpers';
import { useNavigate } from 'react-router-dom';
import __ from 'languages/index';
import { ViewIcon, HideIcon } from '@shopify/polaris-icons';
import { useUserSetNewPassword } from 'queries/user.query';

/**
 * Change his/her password
 * @param param0
 * @returns
 */
export default function ChangeMyPassword() {
  const { mutateAsync: setNewPassword } = useUserSetNewPassword();

  const navigate = useNavigate();

  /**
   * Lấy URL ra... để query. chú ý phải load nội dung mới
   * trong useEffect
   */

  //   let useParam =  {} as any;
  //   useParam = useParams();
  //   let Param = useParam.users_slug || false;

  const [viewPasswordMode, setViewPasswordMode] = useState(false);
  const [viewPasswordMode1, setViewPasswordMode1] = useState(false);
  const [passwordField, setPasswordField] = useState('');
  const [passwordField1, setPasswordField1] = useState('');
  const [passwordField2, setPasswordField2] = useState('');
  const [oldPasswordError, setOldPasswordError] = useState('');
  const [errorInRepeatField, setErrorInRepeatField] = useState(false);
  const [errorInMainField, setErrorInMainField] = useState<boolean | string>(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const generatePasswordAuto = () => {
    let autoPass = helpers.getRandomHash(12);
    setPasswordField1(autoPass);
    setPasswordField2(autoPass);
  };

  useEffect(() => {
    if (!passwordField2) return;
    if (passwordField2 !== passwordField1) {
      setErrorInRepeatField(true);
    } else {
      setErrorInRepeatField(false);
    }
  }, [passwordField2, passwordField1]);

  const submitChangePassword = async () => {
    if (errorInRepeatField || errorInMainField) return;
    setButtonLoading(true);
    await setNewPassword({
      current_password: passwordField,
      password: passwordField2,
    })
      .then(async () => {
        await helpers.sleep(2000);
        setButtonLoading(false);
        navigate('/login');
      })
      .catch((e) => {
        setButtonLoading(false);
        setOldPasswordError(__('old_password_invalid'));
      });
  };

  return (
    <>
      <BlockStack gap={{ xs: '800', sm: '400' }}>
        <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
          <Box as="section" paddingInlineStart={{ xs: '400', sm: '0' }} paddingInlineEnd={{ xs: '400', sm: '0' }}>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                Mật khẩu đăng nhập
              </Text>
            </BlockStack>
          </Box>
          <Card roundedAbove="sm">
            <BlockStack gap="400">
              <Form onSubmit={submitChangePassword}>
                <FormLayout>
                  <TextField
                    error={oldPasswordError}
                    label={__('change_my_password_type_your_old_password')}
                    type={viewPasswordMode ? 'text' : 'password'}
                    value={passwordField}
                    onChange={(e) => setPasswordField(e)}
                    suffix={
                      <InlineStack blockAlign="center">
                        <Button
                          variant="plain"
                          onClick={() => setViewPasswordMode(!viewPasswordMode)}
                          icon={viewPasswordMode ? ViewIcon : HideIcon}
                        ></Button>
                      </InlineStack>
                    }
                    autoComplete="off"
                    autoFocus
                    selectTextOnFocus
                  />

                  <TextField
                    label={__('change_my_password_label')}
                    type={viewPasswordMode1 ? 'text' : 'password'}
                    disabled={passwordField.length < 6}
                    value={passwordField1}
                    error={errorInMainField}
                    onChange={(e) => setPasswordField1(e)}
                    suffix={
                      <InlineStack blockAlign="center">
                        <Button
                          variant="plain"
                          onClick={() => setViewPasswordMode1(!viewPasswordMode1)}
                          icon={viewPasswordMode1 ? ViewIcon : HideIcon}
                        ></Button>
                      </InlineStack>
                    }
                    autoComplete="off"
                    helpText={
                      <>
                        {__(helpers.getPasswordStrengthContext(helpers.getPasswordStrength(passwordField1)))}
                        <ProgressBar
                          progress={helpers.getPasswordStrength(passwordField1) * 20}
                          tone={helpers.getPasswordStrength(passwordField1) < 4 ? 'critical' : 'success'}
                          size="small"
                        />
                      </>
                    }
                  />
                  <TextField
                    label={__('change_my_password_retype_label')}
                    value={passwordField2}
                    disabled={passwordField.length < 6}
                    type={viewPasswordMode1 ? 'text' : 'password'}
                    error={errorInRepeatField}
                    onChange={(e) => setPasswordField2(e)}
                    autoComplete="off"
                  />
                </FormLayout>
                <div style={{ padding: '15px 0' }}>
                  Cần sự an toàn hơn? <Link onClick={generatePasswordAuto}>Tạo mật khẩu</Link> tự động.
                </div>

                <Text as="p" tone="caution">
                  Sau khi thay đổi mật khẩu thành công, bạn sẽ phải đăng nhập lại!
                </Text>
              </Form>
            </BlockStack>
            <br />
            <Divider />
            <br />
            <InlineStack align="end">
              <Button
                icon={SaveIcon}
                onClick={submitChangePassword}
                disabled={helpers.getPasswordStrength(passwordField1) < 4 || errorInRepeatField}
                loading={buttonLoading}
              >
                {__('button_set_my_password')}
              </Button>
            </InlineStack>
          </Card>
        </InlineGrid>
      </BlockStack>
    </>
  );
}
